/**
 * The top-level field names on an `ffs-lta-report` Rolodex entry's `data`.
 *
 * One home for the persisted key strings so the two projections that encode
 * this shape by hand — the writer (`toRolodexEntryPut` in `ffsLtaPublishApi`)
 * and the fail-soft close-out reader (`parseReportSummary` in
 * `ffsReportRecord`) — cannot drift on a field name without a single edit here
 * moving both. Pure (no imports), so either layer can use it.
 */
export const FFS_ENTRY_FIELD = {
  ffsPart: 'ffs_part',
  ffsLevel: 'ffs_level',
  outcome: 'outcome',
  mawp: 'mawp',
  userParams: 'user_params',
  dataValues: 'data_values',
  isDefault: 'is_default',
} as const

/**
 * Keys NESTED under the `outcome` object. `computedAt` is the immutable calc
 * timestamp that gates close-out staleness/comparability, so the writer
 * (`saveOutcome`), the schema (`OutcomeSchema`), and the fail-soft reader
 * (`parseReportSummary`) MUST spell it identically — a writer-only rename would
 * not crash, it would silently make every report read `null` (→ `needs-resave`)
 * and block all close-outs. One home prevents that drift.
 */
export const FFS_OUTCOME_FIELD = {
  computedAt: 'computedAt',
} as const
